import React, { useState } from 'react';
import { Form, Input, Button, message, Typography, Space, Row, Col } from 'antd';
import { UserOutlined, LockOutlined, TeamOutlined, SafetyCertificateOutlined, SafetyOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import Captcha from '../components/Captcha';

const { Title, Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState('');
  const { login } = useAuth();

  const onFinish = async (values) => {
    console.log('onFinish called:', values);
    // 暂时禁用验证码验证，测试登录功能
    // if (!values.captcha || values.captcha.toUpperCase() !== captchaValue.toUpperCase()) {
    //   message.error('验证码错误，请重新输入');
    //   setCaptchaValue('');
    //   return;
    // }

    setLoading(true);
    try {
      console.log('Calling login with:', values.username, values.password);
      const result = await login(values.username, values.password);
      console.log('Login result:', result);
      if (result.success) {
      message.success('登录成功');
        // 登录成功后不需要手动跳转，AuthContext会自动处理
      } else {
        message.error(result.message || '用户名或密码错误');
        // 登录失败时刷新验证码
        setCaptchaValue('');
      }
    } catch (error) {
      console.error('登录异常:', error);
      message.error('登录失败，请稍后重试');
      // 登录失败时刷新验证码
      setCaptchaValue('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* 背景装饰元素 */}
      <div style={{
        position: 'absolute',
        top: '-50%',
        left: '-50%',
        width: '200%',
        height: '200%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px',
        animation: 'float 20s ease-in-out infinite',
        zIndex: 1
      }} className="bg-decoration" />
      
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '10%',
        width: '200px',
        height: '200px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '50%',
        animation: 'pulse 4s ease-in-out infinite',
        zIndex: 1
      }} className="bg-decoration" />
      
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '10%',
        width: '150px',
        height: '150px',
        background: 'rgba(255,255,255,0.05)',
        borderRadius: '50%',
        animation: 'pulse 6s ease-in-out infinite',
        zIndex: 1
      }} className="bg-decoration" />

      {/* 主要内容 */}
      <div style={{
        position: 'relative',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: '0 20px'
      }} className="login-container">
        {/* 右侧登录表单 */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          borderRadius: '20px',
          padding: '30px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
          border: '1px solid rgba(255,255,255,0.2)',
          width: '100%',
          maxWidth: '400px',
          transform: 'translateY(0)',
          transition: 'all 0.3s ease',
          animation: 'slideIn 0.8s ease-out'
        }} className="login-form">
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <Title level={2} style={{ margin: 0, color: '#1890ff' }} className="login-title">
              欢迎登录
            </Title>
            <Text style={{ color: '#666', fontSize: '14px' }} className="login-subtitle">
              请输入您的账号信息
            </Text>
          </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input 
              prefix={<UserOutlined style={{ color: '#1890ff' }} />} 
              placeholder="请输入用户名" 
              style={{
                height: '52px',
                borderRadius: '10px',
                border: '1px solid #d9d9d9',
                transition: 'all 0.3s ease',
                fontSize: '16px'
              }}
              className="input-field"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password 
              prefix={<LockOutlined style={{ color: '#1890ff' }} />} 
              placeholder="请输入密码" 
              style={{
                height: '52px',
                borderRadius: '10px',
                border: '1px solid #d9d9d9',
                transition: 'all 0.3s ease',
                fontSize: '16px'
              }}
              className="input-field"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item
            name="captcha"
            rules={[{ required: true, message: '请输入验证码' }]}
          >
            <Row gutter={8}>
              <Col span={16}>
                <Input 
                    prefix={<SafetyOutlined style={{ color: '#1890ff' }} />} 
                    placeholder="请输入验证码" 
                    style={{
                      height: '52px',
                      borderRadius: '10px',
                      border: '1px solid #d9d9d9',
                      transition: 'all 0.3s ease',
                      fontSize: '16px'
                    }}
                    className="input-field"
                  />
              </Col>
              <Col span={8}>
                <div style={{ height: '52px', display: 'flex', alignItems: 'center' }}>
                  <Captcha 
                    value={captchaValue}
                    onChange={setCaptchaValue}
                    size="large"
                  />
                </div>
              </Col>
            </Row>
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              style={{ 
                width: '100%',
                height: '52px',
                borderRadius: '10px',
                fontSize: '18px',
                fontWeight: 'bold',
                background: '#1890ff',
                border: 'none'
              }}
            >
              登录系统
            </Button>
          </Form.Item>
        </Form>

          <div style={{ 
            textAlign: 'center', 
            marginTop: '24px',
            padding: '16px',
            background: 'rgba(24, 144, 255, 0.05)',
            borderRadius: '8px',
            border: '1px solid rgba(24, 144, 255, 0.1)'
          }}>
            <Text style={{ color: '#666', fontSize: '12px' }}>
              © 2024 HR Pro 智能人力资源管理系统
            </Text>
          </div>
        </div>
      </div>

      {/* 添加CSS动画和响应式样式 */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.1); opacity: 0.8; }
        }
        
        @keyframes slideIn {
          from { 
            opacity: 0; 
            transform: translateX(50px) translateY(20px); 
          }
          to { 
            opacity: 1; 
            transform: translateX(0) translateY(0); 
          }
        }
        
        /* 响应式样式 */
        @media (max-width: 768px) {
          .login-container {
            padding: 0 15px;
          }
          
          .login-form {
            padding: 25px 20px !important;
          }
          
          .login-title {
            font-size: 24px !important;
          }
          
          .login-subtitle {
            font-size: 14px !important;
          }
          
          .input-field {
            height: 48px !important;
            font-size: 14px !important;
          }
          
          .login-button {
            height: 48px !important;
            font-size: 16px !important;
          }
          
          /* 隐藏背景装饰元素，减少移动端性能消耗 */
          .bg-decoration {
            display: none;
          }
        }
        
        /* 触摸设备优化 */
        @media (hover: none) and (pointer: coarse) {
          .login-button {
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.6) !important;
          }
          
          .login-button:active {
            transform: translateY(2px) !important;
            box-shadow: 0 2px 6px rgba(102, 126, 234, 0.4) !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Login; 